import { render, staticRenderFns } from "./MenuItemRecursive.vue?vue&type=template&id=7e311636"
import script from "./MenuItemRecursive.vue?vue&type=script&lang=js"
export * from "./MenuItemRecursive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports